<template lang="html">
  <div class="banner" >
    <div class="container">
      <div class="row">
        <div class="col-md-12">
        </div>
      </div>
    </div>
    <div class="position-relative" v-if="panorama != null && panorama.cFotonaam !== 'geen.jpg'">
      <img :src="panorama.cURL" :alt="type.cMerknaam +' '+ type.cModelnaam +' '+ type.cTypenaam_1 +' '+ Math.round(type.nIngeschatteActieradius) +' km actieradius'" width="100%">
      <Shape class="position-absolute shape left-0"/>
    </div>

  </div>
</template>

<script>
import Shape         from '@/components/design/shape'
export default {
  props:['type', 'panorama'],
  components: {
    Shape
  },
}
</script>

<style media="screen">
  .pattern{
     background-size:100%;
     background-repeat: space;
  }
  .shape{
    bottom:-1px;
  }
</style>
